import React from "react";
import { Skeleton } from "../Skeleton/Skeleton";
import ArrowRightIcon from "../../icons/ArrowRightIcon";
import TruBeLogo from "../../icons/TruBeLogo";

export const EventCardPlaceholder = () => (
  <div className="tbk-bg-white tbk-max-w-sm_ tbk-overflow-hidden tbk-rounded-xl tbk-shadow-trube">
    <Skeleton className="tbk-flex tbk-h-69 tbk-items-center tbk-justify-center tbk-bg-blue-grey-light lg:tbk-h-54">
      <TruBeLogo />
    </Skeleton>
    <div className="tbk-mr-6_ tbk-flex tbk-items-center tbk-py-2 tbk-pl-2">
      <div className="tbk-grow">
        <Skeleton className="tbk-mb-0.5 tbk-h-[30px] tbk-rounded-2xl tbk-bg-blue-grey-light" />
        <div className="tbk-mr-6 tbk-flex tbk-space-x-0.5 ">
          <Skeleton className="tbk-bg-white tbk-h-[28px] tbk-flex-1 tbk-grow tbk-rounded-lg tbk-border tbk-border-blue-grey-light" />
          <Skeleton className="tbk-bg-white tbk-h-[28px] tbk-flex-1 tbk-grow tbk-rounded-lg tbk-border tbk-border-blue-grey-light" />
          <Skeleton className="tbk-bg-white tbk-h-[28px] tbk-flex-[20%] tbk-grow tbk-rounded-lg tbk-border tbk-border-blue-grey-light" />
        </div>
      </div>
      <ArrowRightIcon className="tbk-ml-5 tbk-text-blue-grey-light" />
    </div>
  </div>
);

export default EventCardPlaceholder;
